<span
  *ngFor="let param of tyreParams; let first = first; let last = last"
  [wchfsTooltip]="param.tyre_param_group?.description"
>
  {{ param.code }}
  <ng-container *ngIf="!last">, </ng-container>
  <span class="separator" *ngIf="last && showSeparator">|</span>
</span>
